import { Outlet } from "react-router-dom"
export function DefaultAdminLayout() {
    return (
        <>
            <Outlet />
        </>
    )
}